import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../api/authService';
import '../components/Auth/Auth.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await authService.forgotPassword(email);
      setSuccess(data.message || 'Un code de réinitialisation a été envoyé à votre adresse email.');
    } catch (err) {
      const errors = err.response?.data?.errors;
      if (errors?.email) {
        setError(errors.email[0]);
      } else {
        setError(err.response?.data?.message || 'Une erreur est survenue. Veuillez réessayer.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Tech360</h1>
          <p>Réinitialisation du mot de passe</p>
        </div>

        {success ? (
          <div>
            <div
              style={{
                background: '#f0fff4',
                color: '#276749',
                padding: '14px',
                borderRadius: '6px',
                fontSize: '14px',
                border: '1px solid #9ae6b4',
                marginBottom: '20px',
                lineHeight: '1.5',
              }}
            >
              {success}
            </div>
            <p style={{ fontSize: '14px', color: '#718096', textAlign: 'center' }}>
              Vérifiez votre boîte de réception et cliquez sur le lien reçu, ou{' '}
              <Link to="/reset-password" style={{ color: '#dc143c', textDecoration: 'none', fontWeight: 600 }}>
                saisissez votre code ici
              </Link>
              .
            </p>
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <Link to="/login" style={{ color: '#718096', fontSize: '14px', textDecoration: 'none' }}>
                ← Retour à la connexion
              </Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <p style={{ fontSize: '14px', color: '#718096', margin: '0 0 4px' }}>
              Entrez l'adresse email associée à votre compte. Nous vous enverrons un code de réinitialisation.
            </p>

            {error && <div className="error-message">{error}</div>}

            <div className="form-group">
              <label htmlFor="email">Adresse email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="admin@tech360.com"
                disabled={loading}
              />
            </div>

            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Envoi en cours...' : 'Envoyer le code'}
            </button>

            <div style={{ textAlign: 'center' }}>
              <Link to="/login" style={{ color: '#718096', fontSize: '14px', textDecoration: 'none' }}>
                ← Retour à la connexion
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
